import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, collection, doc, getDoc, query, where, orderBy, limit, Timestamp, getDocs } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getConfig } from 'config/config';

export const firebaseConfig = {
  apiKey: getConfig('REACT_APP_FIREBASE_PUB_KEY'),
  authDomain: getConfig('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  databaseURL: getConfig('REACT_APP_FIREBASE_DATABASE_URL'),
  projectId: getConfig('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getConfig('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getConfig('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getConfig('REACT_APP_FIREBASE_APP_ID'),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const provider = new GoogleAuthProvider();

// Initialize services
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const { now } = Timestamp;
const fbKey = `firebase:authUser:${getConfig('REACT_APP_FIREBASE_PUB_KEY')}:[DEFAULT]`;

const getLocalStorage = () => Object.keys(window.localStorage)
  .filter((item) => item.startsWith('firebase:authUser'))[0];

const fetchUserInfo = async (userId) => {
  try {
    const userRef = doc(firestore, 'users', userId);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      return docSnap.data();
    }
    return {};
  } catch (error) {
    return error;
  }
};

const fetchMostRecentPlaidTransactions = async (orgId) => {
  try {
    const transactionsRef = collection(firestore, 'plaidTransactions');
    const q = query(
      transactionsRef,
      where('organizationId', '==', orgId),
      orderBy('createdAt', 'desc'),
      limit(1),
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null;
    }
    return querySnapshot.docs[0].data();
  } catch (error) {
    console.error('Error fetching the most recent Plaid transaction:', error);
    return null;
  }
};

export {
  app,
  auth,
  firestore,
  now,
  getLocalStorage,
  fbKey,
  fetchUserInfo,
  storage,
  fetchMostRecentPlaidTransactions,
  provider,
};
